var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{ref:"alert-modal",attrs:{"title":"A Roads!","ok-only":true}},[(_vm.title.length > 0)?_c('h3',{staticClass:"my-4"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('p',[_vm._v(" "+_vm._s(_vm.message)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }